export const projectData = [
  {
    title: 'GDGoC Website',
    date: 'Oct 2024',
    description:
      "It allows members to list events, showcase the team, and provide information about the club, fostering engagement and collaboration within the campus tech community.",
    techStack: 'React, React DOM, React Router DOM, Framer Motion, React, Helmet Async, React Icons, Vite, Tailwind CSS, ESLint, PostCSS, Autoprefixer, @vitejs/plugin-react',
    githubUrl: 'https://github.com/ATHARVA262005/gdgocpdeacoe',
    demoUrl: 'https://gdgocpdeacoe.vercel.app',
    thumbnail: 'https://i.postimg.cc/grFW39X4/image-2025-01-05-181958431.png',
    videoUrl: 'https://www.youtube.com/embed/aFu5Hf4JGyI',
  },
];